import { createSelector } from '@ngrx/store';

import { selectCommonBackendDataVersion } from './store/common/common.selectors';
import { selectCountry, selectLanguage, selectSubprocess } from './store/runtime-variables/runtime-variables.selectors';
import type { Subprocess } from './utils/models/subprocess.enum';

type Language = Lowercase<string>;
type Country = Uppercase<string>;
type Market = `${Language}_${Country}`;

export interface ApiContext {
  country: Country;
  language: Language;

  // kind of duplicate (country and language concatenated), but useful for convenience reasons
  // NOTE: format is language_COUNTRY (e.g. de_AT)
  market: Market;

  subProcess: Subprocess;
  // ℹ️ backend data version might not be instantly available. if not available it gets inserted by interceptor
  dataVersion: string | undefined;
}

export const selectApiContext = createSelector(
  selectCountry,
  selectLanguage,
  selectSubprocess,
  selectCommonBackendDataVersion,
  (country, language, subprocess, dataVersion) => ({
    country,
    language,
    market: `${language}_${country}`, // e.g. de_AT
    subProcess: subprocess, // intentionally written differently here
    dataVersion
  })
);
